import {apiClient} from "../utils/Api";
import {LocalStore} from "../utils/LocalStore";
import {AUTH} from "../config/auth";
import cookie from "react-cookies";

export default class UserService {

    static fetchMe = () => {
        return apiClient.get(`/user/detail`);
    };

    static login = (username, password) => {
        return apiClient.post(`/user/login`, {
            username: username,
            password: password,
            device_token: global.deviceToken,
            client_id: AUTH.CLIENT_ID,
            client_secret: AUTH.CLIENT_SECRET,
            grant_type: "password",
        });
    };

    static register = (name, phone, password, email) => {
        return apiClient.post(`/user/register`, {
            name: name,
            phone: phone,
            email: email,
            password: password
        });
    };

    static verifyEmail = (code) => {
        return apiClient.post(`/user/verify-email`, {
            code: code,
        });
    };

    static forgotPassword = (email) => {
        return apiClient.post(`/user/forgot-password`, {
            email: email,
        });
    };

    static resetPassword = (token, password) => {
        return apiClient.post(`/user/reset-password`, {
            password: password,
            token: token,
        });
    };

    static changePassword = (data) => {
        return apiClient.post('/user/change-password', data);
    };

    static refreshToken = (token) => {
        return apiClient.post('/auth/refresh-token', {token});
    };

    static logout = () => {
        cookie.remove('access_token', {path: '/'});
        LocalStore.getInstance().save('urlBack', null);
    };
}